export default __webpack_public_path__ + "11f9793c2df6c61f61fdbb08d147eae4.woff2";